import Checkbox from "@/app/_components/forms/Checkbox";
import Input from "@/app/_components/forms/Input";
import {useContext} from "react";
import {
	CheckboxGroupStateContext,
	CheckboxProps,
	InputProps,
} from "react-aria-components";

interface InputWithCheckboxToggleProps extends CheckboxProps {
	checkboxLabel: string;
	inputProps: InputProps;
}

/**
 * A checkbox that creates an input element when it's checked.
 * At time of writing the input is uncontrolled by the parent and controlled within
 * the InputWithCheckboxToggle component.  It is still able to trigger a callback as needed.
 * We may wish to change this later.  But for now it suits the (weird) use case.
 */
const InputWithCheckboxToggle: React.FC<InputWithCheckboxToggleProps> = ({
	checkboxLabel,
	inputProps,
	...props
}) => {
	const checkboxGroupContext = useContext(CheckboxGroupStateContext);

	return (
		<div className="flex w-full flex-col">
			<Checkbox {...props}>
				<div>{checkboxLabel}</div>
			</Checkbox>
			{checkboxGroupContext?.isSelected(props.value || "") && (
				<div className="py-2 pl-5">
					<Input {...inputProps} />
				</div>
			)}
		</div>
	);
};

export default InputWithCheckboxToggle;
